import UpperButton from "./components/UpperButton/UpperButton";
import RoutesRoot from "./routes/Routes";

function App() {
  return (
    <>
      <div className="w-full h-screen relative">
        <UpperButton />
        <RoutesRoot />
      </div>
    </>
  );
}

export default App;
